/**
 * Pythagorean letter values: A=1 … I=9, then repeat J–R, S–Z.
 */

const LETTERS = 'abcdefghijklmnopqrstuvwxyz';

export function letterValue(ch) {
  const lower = String(ch).toLowerCase();
  if (!/^[a-z]$/.test(lower)) return 0;
  const idx = LETTERS.indexOf(lower);
  return (idx % 9) + 1;
}

export function stripToLetters(str) {
  return String(str || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
}

const VOWELS = new Set(['a', 'e', 'i', 'o', 'u']);

/**
 * Y as vowel: common rule — Y counts as vowel for Soul Urge when it is the last letter
 * of a name part, or when it is not immediately preceded by another vowel (A,E,I,O,U).
 */
export function isYVowel(chars, index) {
  if (chars[index] !== 'y') return false;
  if (index === chars.length - 1) return true;
  const prev = chars[index - 1];
  return !VOWELS.has(prev);
}

/**
 * Sum vowels / consonants across full birth name with Y handling.
 */
export function sumVowelsConsonants(fullBirthName) {
  const clean = String(fullBirthName || '').trim();
  const parts = clean.split(/\s+/).filter(Boolean);
  let vowelSum = 0;
  let consonantSum = 0;

  parts.forEach((part) => {
    const chars = stripToLetters(part).split('');
    chars.forEach((c, i) => {
      const v = letterValue(c);
      const isVowel = VOWELS.has(c) || (c === 'y' && isYVowel(chars, i));
      if (isVowel) vowelSum += v;
      else consonantSum += v;
    });
  });

  return { vowelSum, consonantSum };
}

export function buildNameLetterGrid(fullBirthName) {
  const letters = stripToLetters(fullBirthName).split('');
  const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0 };
  letters.forEach((ch) => {
    const v = letterValue(ch);
    if (counts[v] !== undefined) counts[v] += 1;
  });
  return { letters, counts, totalLetters: letters.length };
}
